import { useSelector } from "react-redux";
import { useState } from "react";
import Spinner from "../spinner";

function JobApproveTimePopup({ selectedSeeker, isApproveTimeLoading, handleApproveTime }) {
  const onApproveClick = async (e) => {
    const approveTimeResponse = await handleApproveTime(e);

    if (approveTimeResponse) {
      const modalElement = document.getElementById("job-approve-time-popup");
      if (modalElement) {
        const modal = window.bootstrap.Modal.getInstance(modalElement);
        modal?.hide();
      }
    }
  };

  return (
    <>
      <div
        className="modal fade twm-sign-up"
        id="job-approve-time-popup"
        aria-hidden="true"
        aria-labelledby="sign_up_popupLabel"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-header">
                <h2 className="modal-title" id="sign_up_popupLabel">
                 Do you want to approve the selected time for {`${selectedSeeker?.firstName} ${selectedSeeker?.lastName}`}?
                </h2>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(e) => onApproveClick(e)}
                  >
                    {isApproveTimeLoading ? <Spinner size="sm" /> : "Yes"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default JobApproveTimePopup;
